import pluralize from 'pluralize'

export const ALERT_ENTITY = 'alert' as const
export const FINDING_ENTITY = 'finding' as const
export type DismissalEntity = typeof ALERT_ENTITY | typeof FINDING_ENTITY

export function pluralizedTexts(entity: DismissalEntity, count: number) {
  const pluralEntity = pluralize(entity, count)
  const isPlural = count !== 1

  const title = `Dismiss ${pluralEntity}`
  const subtitle = `Select a reason to dismiss ${pluralize('this', count)} ${pluralEntity}.`
  const submitButtonLabel = 'Dismiss'

  const delegatedAlertDismissalTitle = `Request to dismiss ${pluralEntity}`

  const delegatedAlertDismissalSubtitle = isPlural
    ? `These ${pluralEntity} need approval before they can be dismissed. Requests are sent to all approvers.`
    : `This ${pluralEntity} needs approval before it can be dismissed. Requests are sent to all approvers.`

  const delegatedAlertDismissalSubmitButtonLabel = 'Submit request'

  const falsePositiveDescription = isPlural
    ? `These ${pluralEntity} are not valid`
    : `This ${pluralEntity} is not valid`
  const usedInTestsDescription = isPlural
    ? `These ${pluralEntity} are not in production code`
    : `This ${pluralEntity} is not in production code`
  const wontFixDescription = isPlural
    ? `These ${pluralEntity} are not relevant`
    : `This ${pluralEntity} is not relevant`

  return {
    title,
    subtitle,
    submitButtonLabel,
    delegatedAlertDismissal: {
      title: delegatedAlertDismissalTitle,
      subtitle: delegatedAlertDismissalSubtitle,
      submitButtonLabel: delegatedAlertDismissalSubmitButtonLabel,
    },
    reasons: {
      falsePositiveDescription,
      usedInTestsDescription,
      wontFixDescription,
    },
  }
}
